export default "__VITE_PUBLIC_ASSET__e23b9634__"